import { createFileRoute } from "@tanstack/react-router"
import Account from "@/app/account/page"

export const Route = createFileRoute("/account")({
  component: Account,
})
